import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faSearch } from "@fortawesome/free-solid-svg-icons";
import FilterContext from "../../../routes/FilterContext";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
// import OfficeDemandSupplyChart from "../dashboard/OfficeDemandSupplyChart";
import RentalsAnalysisChartMap from "./RentalsAnalysisChartMap";
import AssetSummary from "../dashboard/AssetSummary";
import GrossLeasingTrends from "./GrossLeasingTrends";
import TopActiveTenantsMap from "./TopActiveTenantsMap";
import AbsorbtionTrendsMaps from "./AbsorbtionTrendsMaps";
import FutureRentMaps from "./FutureRentMaps";
import md5 from "md5";
import { Link } from "react-router-dom";
import RentBySectors from "./RentBySectors";
import AssetvsMicromarketRent from "./AssetvsMicromarketRent";
import LeaseExpiry from "./LeaseExpiry";
import SectorBreakupActiveTenants from "./SectorBreakupActiveTenants";
import MajorRecentLeaseTransactionsMap from "./MajorRecentLeaseTransactionsMap";
import Transactionsize from "./Transactionsize";
import AssetvsMicromarketWale from "./AssetvsMicromarketWale";
import { BodyAsFormData } from "../../../services/utilities/util";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import OfficeDemandSupply from "./OfficeDemandSupply";
import AssetSummaryMap from "./AssetSummaryMap";
class MapTabs extends React.Component {
  static contextType = FilterContext;
  state = {
    assetDetails: {},
  };
  constructor(props) {
    super(props);
    console.log(props, "propsmaptabs");
    this.state = {
      tabIndex: this.props.tabIndex,
      assetDetails: [],
      update: this.props.update,
    };
  }

  componentDidMount() {
    apiMiddleware
      .post(
        "api/edge/office/get_asset_details",
        BodyAsFormData(JSON.stringify(this.props.apiData))
      )
      .then((res) => {
        console.log(res);
        this.setState({ assetDetails: res.data });
      });
  }

  componentDidUpdate() {
    if (this.state.tabIndex == 2 && this.state.update) {
      console.log("hello");
      apiMiddleware
        .post(
          "api/edge/office/get_asset_details",
          BodyAsFormData(JSON.stringify(this.props.apiData))
        )
        .then((res) => {
          console.log(res);
          this.setState({ assetDetails: res.data, update: false });
        });
    }
  }

  getAssetDetails(index) {
    console.log(index);
    this.setState({
      tabIndex: index,
    });
    if (index == 2) {
      console.log("pp");
      apiMiddleware
        .post(
          "api/edge/office/get_asset_details",
          BodyAsFormData(JSON.stringify(this.props.apiData))
        )
        .then((res) => {
          console.log(res);
          this.setState({ assetDetails: res.data });
        });
    }
  }

  render() {
    return (
      <Tabs
        defaultIndex={0}
        selectedIndex={this.state.tabIndex}
        onSelect={(index) => this.getAssetDetails(index)}
      >
        <TabList>
          <Tab>Summary</Tab>
          <Tab>Demand, Supply & Pricing</Tab>
          <Tab>Asset Level</Tab>
        </TabList>

        <TabPanel>
          <div className="widget  mb-3">
            <div className="container-fluid p-0 aseetContent mapsUl">
              <div className="row">
                <div className="row">
                  <div className="col-lg-12 text-start mb-3">
                    <h5>Lease Summary</h5>
                  </div>
                </div>
                <div className="col-lg-6">
                  <ul className="detailsUl">
                    <li className="liBlueBg">
                      <span># of Built Assets</span>
                      <span>{this.props.summary.no_of_assets}</span>
                    </li>
                    <li>
                      {" "}
                      <span># of Buildings</span>
                      <span>{this.props.summary.no_of_building}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Total Leasable Area</span>
                      <span>{this.props.summary.total_leasable_area}</span>
                    </li>
                    <li>
                      {" "}
                      <span>% Occupancy</span>
                      <span>{this.props.summary.occupied_perc} %</span>
                      {/* <span>-</span> */}
                    </li>
                    <li>
                      {" "}
                      <span>Current Rental (₹/sqft/month)</span>
                      <span>{this.props.summary.current_rental}</span>
                    </li>
                    <li>
                      {" "}
                      <span>WALE</span>
                      <span>{this.props.summary.wale}</span>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <ul className="detailsUl">
                    <li className="liBlueBg">
                      <span># Upcoming Assets</span>
                      <span>
                        {this.props.summary.no_of_under_construction_assets}
                      </span>
                    </li>
                    <li>
                      {" "}
                      <span>Occupied Area</span>
                      <span>{this.props.summary.occupied_area}</span>
                    </li>
                    <li>
                      {" "}
                      <span># of Active Occupiers</span>
                      <span>{this.props.summary.active_tenants}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Avg Quarterly Supply</span>
                      <span>{this.props.summary.avg_quarterly_supply}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Avg Quarterly Demand</span>
                      <span>{this.props.summary.avg_quarterly_demand}</span>
                    </li>
                    <li>
                      {" "}
                      <span>5-Yrs CAGR Growth in Rental</span>
                      <span>{this.props.summary.five_year_cagr_rent}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="mb-3">
            <OfficeDemandSupply
              apiData={
                this.props.apiData.complexes.length == 0
                  ? this.props.bounds
                  : this.props.apiData
              }
            />
          </div>
          <div className="mb-3">
            <RentalsAnalysisChartMap
              apiData={
                this.props.apiData.complexes.length == 0
                  ? this.props.bounds
                  : this.props.apiData
              }
            />
          </div>
          <div className="mb-3">
            <AssetSummaryMap
              apiData={
                this.props.apiData.complexes.length == 0
                  ? this.props.bounds
                  : this.props.apiData
              }
            />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="widget mapAsset mb-3">
            <div className="container-fluid p-0 aseetContent mapsUl">
              <div className="row">
                <h2>
                  {/* {this.state.assetDetails.asset_name} */}
                  {this.state.assetDetails.asset_name !== undefined ? (
                    <Link
                      target="_blank"
                      to={`/office/asset/?filter={"complex":[{"id":"b-${md5(
                        this.state.assetDetails.asset_name
                      )}","value":"${
                        this.state.assetDetails.asset_name
                      }","label":"${this.state.assetDetails.asset_name}"}]}`}
                    >
                      {this.state.assetDetails.asset_name}
                    </Link>
                  ) : (
                    this.state.assetDetails.asset_name
                  )}
                  {/* <span>
                    <FontAwesomeIcon icon={faStar} size="md" />
                  </span> */}
                </h2>
                <ul className="descriptionUl ps-3">
                  <li>{this.state.assetDetails.propertytype}</li>
                  <li>{this.state.assetDetails.micromarket}</li>
                  <li>{this.state.assetDetails.grade}</li>
                </ul>
                <div className="col-lg-6">
                  <ul className="detailsUl detailsUlAsset">
                    <li className="liBlueBg">
                      <span>Year constructed</span>
                      <span>{this.state.assetDetails.year_constructed}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Developer</span>
                      {/* <span>{this.state.assetDetails.developer}</span> */}
                      {this.state.assetDetails.developer !== undefined ? (
                        <span>
                          <Link
                            className="mapAssetdevSpan"
                            target="_blank"
                            to={`/office/developer/?filter={"developer":[{"id":"d-${md5(
                              this.state.assetDetails.developer
                            )}","value":"${
                              this.state.assetDetails.developer
                            }","label":"${
                              this.state.assetDetails.developer
                            }"}]}`}
                          >
                            {this.state.assetDetails.developer}
                          </Link>
                        </span>
                      ) : (
                        this.state.assetDetails.developer
                      )}
                    </li>
                    <li>
                      {" "}
                      <span>Satus</span>
                      <span>{this.state.assetDetails.status}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Total Leasable Area</span>
                      <span>{this.state.assetDetails.total_leasable_area}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Area Vacant</span>
                      <span>{this.state.assetDetails.area_vacant}</span>
                    </li>
                    <li className="liBlueBg">
                      <span>Asset Efficiency</span>
                      <span>{this.state.assetDetails.asset_efficiency}</span>
                    </li>
                    <li>
                      {" "}
                      <span>WALE</span>
                      <span>{this.state.assetDetails.wale}</span>
                    </li>
                    <li>
                      {" "}
                      <span>Upcoming Area</span>
                      <span>{this.state.assetDetails.upcoming_area}</span>
                    </li>
                    <li className="liBlueBg">
                      <span>Market Rent (₹/sqft/month)</span>
                      <span>{this.state.assetDetails.market_rent}</span>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <div className="col-lg-12 contentBlue pt-0 mb-4">
                    <div className="customWidget contentBlueMaps assetBlueWidget">
                      <div className="row">
                        <div className="col-lg-4 flexCenter">
                          <h3>
                            <FontAwesomeIcon
                              icon={faSearch}
                              className="colorWhite"
                            />
                          </h3>
                        </div>
                        <div className="col-lg-8">
                          <h2 className="colorWhite customSize">
                            {this.state.assetDetails.current_vacancy}
                          </h2>
                          {/* <h2 className="colorWhite customSize">-</h2> */}
                          <p className="colorWhite">Current Vacancy</p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="customWidget contentBlueMaps assetBlueWidget"
                      style={{ borderBottom: "0" }}
                    >
                      <div className="row">
                        <div className="col-lg-4 flexCenter">
                          <h3>
                            <img
                              src="/edge/images/current_passing_rent_white.png"
                              width={"45px"}
                            />
                          </h3>
                        </div>
                        <div className="col-lg-8">
                          <h2 className="colorWhite customSize">
                            {this.state.assetDetails.current_in_place_rentals}
                          </h2>
                          <p className="colorWhite">Sqft/Month</p>
                          <p
                            className="colorWhite"
                            style={{ fontSize: "10px" }}
                          >
                            Current in Place Rentals
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ul className="detailsUl detailsUlAsset">
                    <li>
                      {" "}
                      <span>5-Yr CAGR Rent</span>
                      <span>{this.state.assetDetails.five_year_cagr_rent}</span>
                    </li>
                    <li>
                      {" "}
                      <span># of active Occupiers</span>
                      <span>
                        {this.state.assetDetails.no_of_active_tenants}
                      </span>
                    </li>
                    <li>
                      {" "}
                      <span>% Occupancy</span>
                      <span>
                        {this.state.assetDetails.current_vacancy != "-"
                          ? 100 -
                            parseInt(
                              this.state.assetDetails.current_vacancy,
                              10
                            )
                          : "-"}
                      </span>
                      {/* <span>-</span> */}
                    </li>
                    <li>
                      {" "}
                      <span>Market Rent (₹/sqft/month)</span>
                      <span>{this.state.assetDetails.market_rent}</span>
                    </li>
                    {/* <li>
                      {" "}
                      <span>Micromarket</span>
                      <span></span>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <Tabs>
            <TabList className={"innerTabs"}>
              <Tab>Demand</Tab>
              <Tab>Rentals</Tab>
              <Tab>Transaction Data</Tab>
              <Tab>Charts</Tab>
            </TabList>

            <TabPanel>
              <div className="mb-3">
                <GrossLeasingTrends apiData={this.props.apiData} />
              </div>
              <div className="mb-3">
                <TopActiveTenantsMap apiData={this.props.apiData} />
              </div>
              <div className="mb-3">
                <AbsorbtionTrendsMaps apiData={this.props.apiData} />
              </div>
            </TabPanel>
            <TabPanel>
              <div className="mb-3">
                <RentalsAnalysisChartMap apiData={this.props.apiData} />
              </div>
              <div className="mb-3">
                <FutureRentMaps apiData={this.props.apiData} />
              </div>
              <div className="mb-3">
                <RentBySectors apiData={this.props.apiData} />
              </div>
              <div className="mb-3">
                <AssetvsMicromarketRent apiData={this.props.apiData} />
              </div>
            </TabPanel>
            <TabPanel>
              <MajorRecentLeaseTransactionsMap apiData={this.props.apiData} />
            </TabPanel>
            <TabPanel>
              <div className="mb-3">
                <LeaseExpiry apiData={this.props.apiData} />
              </div>
              <div className="mb-3">
                <SectorBreakupActiveTenants apiData={this.props.apiData} />
              </div>
              <div className="mb-3">
                <Transactionsize apiData={this.props.apiData} />
              </div>
              <div className="mb-3">
                <AssetvsMicromarketWale apiData={this.props.apiData} />
              </div>
            </TabPanel>
          </Tabs>
        </TabPanel>
      </Tabs>
    );
  }
}

export default MapTabs;
